import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { ClockTick } from 'record-it-utils/utils/ClockTick/ClockTick';
import { useEventCallback } from './useEventCallback';
export function useDayTick(callback) {
  const $ = _c(3);
  const wrappedCallback = useEventCallback(callback);
  let t0;
  let t1;
  if ($[0] !== wrappedCallback) {
    t0 = () => {
      const disposable = ClockTick.onDayTick(wrappedCallback);
      return () => disposable.dispose();
    };
    t1 = [wrappedCallback];
    $[0] = wrappedCallback;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}